import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'



import Store from '@/store/Store';

import Bus from "@/lib/Bus";


const bus: Bus = new Bus().getBus();

import { RouterHistory } from './RouterHistory';
const history: RouterHistory = new RouterHistory().class();


const store = new Store()
Vue.use(VueRouter)

const routes = history.get_routes();

const router = new VueRouter({  mode: 'history',  base: 'app',  routes, linkActiveClass: "router-active", linkExactActiveClass: "router-exact-active", })

router.beforeEach(async (to, from, next) => {
  console.log("beforeEach from:", from.name, " to:", to.name)
  console.log("beforeEach from:", from.path, " to:", to.path)

  bus.before_path_change(from.fullPath, to.fullPath)
  Bus.set_current_path(to.fullPath)
  await bus.wait_completed();

  console.log("beforeEach wait completed")
 

  if (await store.getStore()){   next();   }
  else console.log("getStore problem")



});



router.afterEach(async (to, from) => {
  //console.log("******************************** afterEach:", to.path)
  bus.fire("history_changed",{})
});

function patchRouterMethod (router:any, methodName:string) {
    router['old' + methodName] = router[methodName]
    router[methodName] = async function (location:any)
    {
        return router['old' + methodName](location).catch((error:any) =>
        {
            if (error.name === 'NavigationDuplicated')
            {
                console.log("route duplicated")
                return this.currentRoute
            }
            throw error
        })
    }
}

patchRouterMethod(router, 'push')
patchRouterMethod(router, 'replace')

declare global {
  // eslint-disable-next-line no-unused-vars
  interface Window {     router: VueRouter;  }
}
window.router = router;
export default router
